import React from "react";
import '../styles/About.css';

function About() {
    return (
        <div className="divAbout">
            <h2>About Page</h2>

            texto div 1.1

            <div style={{ color: 'red', backgroundColor: "#222299", fontWeight: "bold" }}>Div 2</div>

            Texto div 1.2

            <div style={{ width:"100px", color: '#fff', backgroundColor: "#000000", fontWeight: "bold", justifySelf:"center", textAlign:"center" }}>Div 3</div>

            Texto div 1.3

            <hr />
        </div>
    );
}

export default About;